export const RED = `#c20051` as const;
export const BLUE = `#3600a8` as const;
export const DEEP_BLACK = `#242424` as const;
export const BLACK = `#333333` as const;
export const GOLD = `#8A7300` as const;
export const WHITE = `#ffffff` as const;
export const LIGHT_GREY = `#F7F7F7` as const;
